module.exports = __webpack_public_path__ + "img/share.7898fa31.png";